'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import { NoDataMessage } from '@/components/molecules';

export default function Error({ error }: { error: Error }) {
	useEffect(() => {
		Sentry.captureException(error);
	}, [error]);

	return (
		<NoDataMessage
			title="Unexpected error"
			description="An unexpected error occurred while fetching the data. Please try again, or contact support if the issue persists."
		/>
	);
}
